import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleMilestoneRemoval(
  state: State,
  milestone: Boundaries["removeMilestone"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      milestones: req.calendar.milestones.filter(
        ({ uuid }) => milestone.uuid !== uuid,
      ),
    },
  }));
}

export { handleMilestoneRemoval };
